/* 🤖 this file was generated by svg-to-ts */
export const matIconSystemUpdateAlt: {
  name: 'system-update-alt';
  data: string;
} = {
  name: 'system-update-alt',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="m12 16 4-4h-3V3h-2v9H8l4 4zm9-13h-6v1.99h6v14.03H3V4.99h6V3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9 13 4-4h-3V3h-2v9H8l4 4zm9-13h-6v1.99h6v14.03H3V4.99h6V3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"/></svg>`
};
